import { FC } from "react";

import { InitialScreenMolecule } from "../../molecules";

import blue from "../../../assets/images/blue.png";
import yellow from "../../../assets/images/yellow.png";
import green from "../../../assets/images/green.png";
import pink from "../../../assets/images/pink.png";

const InitialScreen: FC<{}> = () => {

    return (
        <div className="initial_screen">
            <div className="initial_screen__row">
                <div className="initial_screen__row_box">
                    <img src={green} alt="logo" className="initial_screen__row_box__icon" />
                </div>
                <div className="initial_screen__row_box">
                    <img src={pink} alt="logo" className="initial_screen__row_box__icon" />
                </div>
            </div>

            <div className="initial_screen__dialog_box">
                <InitialScreenMolecule />
            </div>

            <div className="initial_screen__row">
                <div className="initial_screen__row_box">
                    <img src={blue} alt="logo" className="initial_screen__row_box__icon" />
                </div>
                <div className="initial_screen__row_box">
                    <img src={yellow} alt="logo" className="initial_screen__row_box__icon" />
                </div>
            </div>
        </div>
    );
};

export default InitialScreen;